module.exports = __webpack_public_path__ + "static/media/blog6.b9a0fed5.jpg";